import { render, staticRenderFns } from "./SendEnvelope.vue?vue&type=template&id=33c2f1a4&scoped=true&"
import script from "./SendEnvelope.vue?vue&type=script&lang=js&"
export * from "./SendEnvelope.vue?vue&type=script&lang=js&"
import style0 from "./SendEnvelope.vue?vue&type=style&index=0&id=33c2f1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2f1a4",
  null
  
)

export default component.exports